<template>
    <div class="timelineStep">
        <span v-if="label" class="timelineStep__label">
            {{ label }}
        </span>
        <div>
            <p class="timelineStep__header">{{ header }}</p>
            <p class="timelineStep__desc">{{ text }}</p>
            <CSButton
                v-if="button"
                :id="`timelineStep_${label}_button`"
                :to="button.to"
                :href="button.href"
                :text="button.text"
                class="timelineStep__button"
                outline
                :on-click="
                    () =>
                        trackEventForUserActions(
                            'Timeline',
                            button.href || button.to,
                            button.text,
                        )
                "
            />
        </div>
    </div>
</template>

<script>
import CSButton from '@/components/atoms/button/CSButton.vue'

export default {
    name: 'TimelineStep',

    components: {
        CSButton,
    },

    props: {
        label: {
            type: String,
        },
        header: {
            type: String,
        },
        text: {
            type: String,
        },
        button: {
            type: Object,
        },
    },
}
</script>

<style lang="stylus">
.timelineStep {
    margin-left: $cs-spaces.half;

    @media $display-breakpoints.sm-and-up {
        display: flex;
        margin-left: $cs-spaces.onehalf;
    }

    &:last-child {
        padding: 0;
    }

    &__label {
        font-size: 22px;
        font-weight: 700;
        line-height: 1;
        margin: 0 0 $cs-spaces.half;
        min-width: $cs-space;

        @media $display-breakpoints.sm-and-up {
            margin: 0 $cs-space 0 0;
        }
    }

    &__header {
        margin: 0;
    }

    &__desc {
        color: $cs-slate-300;
        display: block;
        margin: $cs-spaces.half 0 0;
    }

    &__button {
        margin: $cs-spaces.half 0 0;
    }
}
</style>
